import API, { defaultHeaders } from '@/api';
import Storage from '@/service/Storage';

const courses = () => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${Storage.getItem('token')}`;
  return fetch(`${API}/courses`, { headers });
};

export default courses;
